import { useState } from 'react';

import { AccordionPlus } from './AccordionPlus';
import { Schema } from './AccordionsPlus.schema';

import { Svg } from '../../snippets';

export function AccordionsPlus({ cms }) {
  const { accordions, heading, accordionSettings, popUp, section } = cms;
  const [areOpen, setAreOpen] = useState(accordionSettings?.defaultOpen || false);

  return (
    <div className="px-contained my-4 md:my-8 xl:my-12">
      <div className={`mx-auto ${accordionSettings?.width}`}>
        {heading && (
          <h2 className={`text-title-h2 mb-4 text-center ${section?.hideHeading ? 'sr-only' : ''}`}>{heading}</h2>
        )}

        <div className="flex justify-end mb-4">
          <button
            aria-label={`${ areOpen ? 'Open' : 'Close'} accordions`}
            className="shadow-hairline flex items-center justify-between gap-1 md:gap-4 bg-offWhite p-2 md:p-3 text-base hover:bg-white"
            onClick={() => setAreOpen(!areOpen)}
            type="button"
          >
            <Svg
              className="text-text"
              src={`/svgs/${areOpen ? 'contract' : 'expand'}.svg#${areOpen ? 'contract' : 'expand'}`}
              alt="Accordion Icon"
              title="Accordion"
              viewBox="0 0 24 24"
              width="24px"
              height="24px"
            />
          </button>
        </div>

        <ul className="grid grid-cols-1 gap-4">
          {accordions?.map((accordion, index) => {
            return (
              <li key={index}>
                <AccordionPlus
                  accordion={accordion}
                  accordionSettings={accordionSettings}
                  areOpen={areOpen}
                  popUp={popUp}
                />
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}

AccordionsPlus.displayName = 'AccordionsPlus';
AccordionsPlus.Schema = Schema;
